import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSingleEffect } from 'react-haiku';
import { useCollect, useRequest } from 'hooks';

import Modal from 'components/Modal';
import { Title } from 'components/Misc/Typography';
import { Form, Select, Button, Textarea } from 'components/Misc/Form';

import Award from './Award';

const Awards = () => {
	// Cache current object's id
	const { id } = useParams();

	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Store data
	const [award, setAward] = useState({
		studentId: id,
		type: '',
		for: ''
	});

	// Store request parameters
	const parameters = useMemo(() => ({
		studentId: id
	}), [id]);

	// Store request
	const [, request] = useRequest('post', 'awards');

	// Store requested user
	const [[awards, progress], collect] = useCollect('awards', parameters);

	// Collect user on mount and on parameter change
	useSingleEffect(() => {
		(async () => await collect())();
	});

	// Toggle modal's visibility
	const onModal = () => setModal(m => !m);

	const onChange = event => {
		setAward(prev => ({
			...prev,
			[event.name]: event.value
		}));
	};

	// Handle submit event
	const onSubmit = async (event) => {
		event.preventDefault();

		// Try to create award
		const [success, error] = await request(award);

		console.log(success);
	};

	return (
		<div className="space-y-4">
			<div className="flex">
				<Title
					title="Apbalvojumi"
					className="flex-1"
				/>

				<Button
					small
					square
					icon="add"
					theme="success"
					onClick={onModal}
				/>
			</div>

			<div className="space-y-2">
				{awards?.map(award =>
					<Award key={award.id} award={award} />
				)}
			</div>
			
			<Modal title="Pievienot apbalvojumu" visible={modal} handleModal={onModal}>
				<Form
					onSubmit={onSubmit}
					className="flex flex-col gap-4"
				>
					<Select
						name="type"
						label="Tips"
						placeholder=" "
						value={award.type}
						onChange={onChange}
						options={[
							{ value: 'attendance', name: 'Piedalījās' },
							{ value: 'award', name: 'Apbalvojums' }
						]}
					/>

					<Textarea
						name="for"
						label="Apraksts"
						value={award.for}
						onChange={onChange}
					/>

					<div className="md:col-span-2 flex justify-end">
						<Button
							submit
							icon="done"
							value="Izveidot"
							theme="success"
							progress={progress}
						/>
					</div>
				</Form>
			</Modal>
		</div>
	);
};

export default Awards;